module.exports = __webpack_public_path__ + "img/30.9720a421.png";